import { Theme } from '@mui/material/styles';

export const TIME_SERIES_CHART_HEIGHT = 200;
export const TIME_SERIES_CHART_MARGIN = { top: 10, right: 30, left: 10, bottom: 5 };
export const TIME_SERIES_TEXT_STYLE = { fontSize: '10px' };

export const TIME_SERIES_COLORS = {
  blue: '#0369a1',
  green: '#0f766e',
  purple: '#7c3aed',
  amber: '#b45309',
  pink: '#be185d',
  slate: '#475569',
  olive: '#4d7c0f',
};

export function getTimeSeriesTooltipStyles(theme: Theme) {
  const { palette } = theme;
  return {
    contentStyle: {
      ...TIME_SERIES_TEXT_STYLE,
      backgroundColor: palette.background.paper,
      borderColor: palette.divider,
      color: palette.text.primary,
    },
    labelStyle: { color: palette.text.primary },
    itemStyle: { color: palette.text.primary },
  };
}
